import {
  Grid,
} from '@material-ui/core';
import { searchBusinessPartners } from '@webapps/business';
import {
  Modal,
  PaginationNumbers,
  useAuth,
  useQuery,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import { useFormik } from 'formik';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import AddPartner from './AddPartner';
import PartnerCard from './PartenerCard';
import FilterPartners from './FilterPartners';
import NoResult from './NoResult';

const Partner = ({ from, accept, setTotalElements }) => {
  const {
    classes,
    theme: { spacing },
  } = useStyles(styles);

  const { idUser } = useAuth();

  const [page, setPage] = useState(1);
  const [size, setSize] = useState(12);
  const [addPartner, setAddPartner] = useState(false);

  const location = useLocation();

  const [keywordRequest, setKeywordRequest] = useState('');
  const [trainingDomainsRequest, setTrainingDomainsRequest] = useState('');
  const [degreeLevelsRequest, setDegreeLevelsRequest] = useState('');
  const [trainingTypesRequest, setTrainingTypesRequest] = useState('');

  const { data: { content: partners = [], totalElements } = {}, refetch } = useQuery(searchBusinessPartners, {
    key: ['schoolsPartnersRequest', page, size, idUser, keywordRequest, trainingDomainsRequest, degreeLevelsRequest, trainingTypesRequest, from, accept],
    variables: {
      id: idUser,
      keyword: keywordRequest,
      trainingDomains: trainingDomainsRequest,
      degreeLevels: degreeLevelsRequest,
      trainingTypes: trainingTypesRequest,
      from,
      accept,
      page: page - 1,
      size
    },
    keepPreviousData: true,
    staleTime: 5000,
  });

  const formik = useFormik({
    initialValues: {
      keyword: '',
      trainingDomains: [],
      degreeLevels: [],
      trainingTypes: [],
    },
    onSubmit: ({
      keyword,
    }) => {
      setKeywordRequest(keyword);
      setTrainingDomainsRequest(formik.values?.trainingDomains);
      setDegreeLevelsRequest(formik.values?.degreeLevels);
      setTrainingTypesRequest(formik.values?.trainingTypes);
      setPage(1);
    },
  });

  useEffect(() => {
    const handler = setTimeout(() => {
      formik.handleSubmit();
    }, 500);

    return () => {
      if (formik.values.keyword !== keywordRequest)
        clearTimeout(handler);
      else
        formik.handleSubmit();
    };
  }, [formik.values]);

  useEffect(() => {
    if (location?.state?.addPartner) {
      if (totalElements > 0) {
        setAddPartner(true);
        location.state.addPartner = false;
      }
    }
  }, [location, totalElements]);

  useEffect(() => {
    setTotalElements(totalElements);
  }, [totalElements]);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        rowGap: '20px',
        height: '100%',
      }}
    >
      <Grid container className={classes.filterContainer}>
        <FilterPartners formik={formik} partners={partners} refetch={refetch} accept={accept} />
      </Grid>
      {!partners?.length ? (
        <Grid className={classes.noResultContainer} container >
          <NoResult refetch={refetch} />
        </Grid>
      ) : (
        <Grid className={classes.PartenerCardContainer} container>
          {partners?.map(
            (info) => (
              <Grid key={info.id} item xs={12} sm={6} md={4} xl={3} style={{ padding: spacing(0, 2.5, 2.5, 0) }} >
                <PartnerCard
                  info={info}
                  refetch={refetch}
                  type={from}
                  accept={accept}
                />
              </Grid>
            )
          )}
        </Grid>
      )}
      <PaginationNumbers
        onChange={(newPage) => setPage(newPage)}
        page={page}
        pageCount={size}
        totalCount={totalElements}
      />
      <Modal
        onCancel={() => setAddPartner(false)}
        open={addPartner}
        title="Rechercher un partenariat"
        titleFontSize={'20px'}
        titleFontWeigth={500}
        maxWdth={'80%'}
      >
        <AddPartner close={() => setAddPartner(false)} refetch={refetch} />
      </Modal>
    </div>
  );
};

const styles = ({ spacing }) => ({
  filterContainer: {
    columnGap: 10,
    '@media screen and (max-width: 768px)': {
      flexDirection: 'column',
      columnGap: 0,
      rowGap: 10,
    }
  },
  noResultContainer: {
    backgroundColor: '#F3F7FF',
    borderRadius: 20,
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 'calc(100vh - 75px - 193px)',
    padding: spacing(2.5),
    '@media (max-width:768px)': {
      margin: spacing(0),
    },
  },
  profilName: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    marginLeft: spacing(2),
  },
  avatar: {
    height: 60,
    width: 60,
  },
  gridContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  PartenerCardContainer: {
    backgroundColor: '#F3F7FF',
    borderRadius: 20,
    padding: spacing(2.5, 0, 0, 2.5),
    '@media (max-width:768px)': {
      margin: spacing(0),
    },
  },
});

export default Partner;
